import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=4719264c"
import script from "./modify.vue?vue&type=script&lang=ts"
export * from "./modify.vue?vue&type=script&lang=ts"
import style0 from "./modify.vue?vue&type=style&index=0&id=4719264c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports